import React from 'react';

export const Button = ({disabled = false, id = '', btnClassName = '', btnStyle = {}, textStyle = {}, textClassName = '', text = '', onPress = () => {}}) => {
    return (
        <button disabled={disabled} id={id} onClick={onPress} className={`${disabled ? 'bg-disabled' : 'bg-blue'} padding-h-8 padding-v-12 border-radius-8 ${btnClassName}`} style={{width: '100%', ...btnStyle}}>
            <div style={{...textStyle}} className={`font color-white font-size-16 line-height-20 ${textClassName}`}>{text}</div>
        </button>
    )
}